import * as React from "react";
import { css } from "aphrodite";
import { HorizontalRuleStyle, IStyle } from "./HorizontalRuleStyle";

interface IProps {
  styles?: IStyle;
}

export const HorizontalRule: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const horizontalRuleStyle: any = props.styles
    ? props.styles.horizontalRule
    : null;
  return (
    <hr
      className={css(HorizontalRuleStyle.horizontalRule, horizontalRuleStyle)}
    />
  );
};
